import styled from 'styled-components';

export const Container = styled.div`
  > p {
    font-family: 'Montserrat';
    font-weight: bold;
    font-size: 1.6rem;
    color: var(--purple27);
    text-align: center;
    margin-top: 60px;
    margin-bottom: 40vh;
  }
`;
